<template>
  <div class="ent_object">
    <router-link to="/">返回</router-link>
    <h2 class="blue_title">企业征信异议须知</h2>
    <p class="content-text-indent">根据《金融信用信息基础数据库企业征信异议处理业务规程》，企业认为企业信用报告中的信息存在错误、遗漏的，可由企业法定代表人或委托经办人向征信中心、各地征信分中心提出异议申请。</p>
    <span class="blue_span">一、企业征信异议申请流程：</span>
    <div>
      <p class="content-text-indent">填表→微信预约→出示预约信息→提交材料→征信中心审核受理→若受理的，待处理后送达异议回复函（见附件3）；若不受理的，予以退回并告知不予接收的原因。</p>
    </div>
    <span class="blue_span">二、企业征信异议申请提交材料顺序如下：（用A4纸规格，除申请表外，其他资料必须加盖单位公章）</span>
    <div>
      <p class="content-text-indent">1、填写《企业征信异议申请表》（见附件1)；</p>
      <p class="content-text-indent">2、有效执照/注册登记证（统一社会信用代码）证件原件及复印件（见特别提示2）；<b class="red">（温馨提示：为预防企业查询信息定位出错，建议提供信用机构代码证号供查验，如不能提供，系统可能会出现借款人不存在或空白，无法正常查询）</b></p>
      <p class="content-text-indent">3、企业法定代表人提出异议申请的，需提供企业法人有效身份证件原件及复印件；</p>
      <p class="content-text-indent">4、企业法人委托经办人代理提出异议申请的，需提供《企业法定代表人授权委托书》(见附件2)；同时提供经办人有效身份证件原件及复印件。<b class="red">（温馨提示：企业法定代表人授权委托书须法人亲笔签字）</b></p>
      <p class="content-text-indent">5、出示与异议信息内容相关的说明材料；</p>
      <p class="content-text-indent">6、提交企业认为存在异议当页的企业信用报告。</p>
    </div>
    <span class="blue_span">三、受理时间：</span>
    <div>
      <p class="content-text-indent">星期一至星期五（国家规定节假日除外）</p>
      <p class="content-text-indent">上午：8：30--11：30，下午：14：00--17：00</p>
    </div>
    <span class="red_span">特别提示：</span>
    <div>
      <p class="content-text-indent">1、复印件中的文字及图案要求清晰不能有遮挡（包括公章的遮挡）；</p>
      <p class="content-text-indent">2、企业有效证件包括：营业执照、事业单位法人证书、社会团体法人登记证书等登记管理部门颁发的合法证照；</p>
      <p class="content-text-indent">3、有效身份证件包括：中国公民的居民身份证，军人的军官证、士兵证，港澳台人士的通行证，外籍人士的护照（外籍人士护照须提交领事馆或公证处的翻译证明文件原件及复印件）。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EntObject.vue'
}
</script>

<style scoped>
.ent_object {
  padding: 20px;
}

.blue_title {
  text-align: center;
  font-size: 20px;
  font-weight: normal;
  color: #3b88d6;
}

.blue_span {
  margin-top: 20px;
  font-size: 14px;
  line-height: 30px;
  color: #3b88d6;
}

.red_span {
  margin-top: 20px;
  font-size: 14px;
  line-height: 30px;
  color: #f00;
}

.content-text-indent {
  text-indent: 2em;
  font-size: 12px;
  margin: 0;
  color: #999;
  line-height: 24px;
}

.red {
  color: #f00;
  font-weight: 400;
}
</style>
